export default __webpack_public_path__ + "resources/icons/d120-dc59.webp";